<template>
  <v-container v-if="apiLoaded">
    <div class="project-card">
      <h1>
        <span>{{ projectCommonInfo.shortName && projectCommonInfo.shortName + " | " }} {{ projectCommonInfo.fullName
        }}</span>
      </h1>

      <div class="badge">
        {{
          projectCommonInfo.status
            ? projectStatusDict[projectCommonInfo.status]
            : '-'
        }}
      </div>

      <div class="tabs-wrap">
        <v-tabs>
          <v-tab>Информация</v-tab>
          <v-tab>Финансы</v-tab>
          <v-tab>Участники и вклады</v-tab>

          <v-tab-item>
            <div class="buttons">
              <v-btn @click="$router.push('/projectEdit/' + projectId)">Редактировать</v-btn>
            </div>

            <div class="grid30">
              <div>
                <h2>Общая информация</h2>

                <h4>№</h4>
                <p>{{ projectCommonInfo.number }}</p>

                <h4>дата начала и окончания</h4>
                <p>
                  {{ projectCommonInfo.startDate | formatDate }} –
                  {{ projectCommonInfo.endDate | formatDate }}
                </p>

                <h4>Руководитель</h4>
                <p v-if="projectCommonInfo.offerExpert">
                  <router-link :to="projectCommonInfo.offerExpert ?
                    `'/employee/' +  ${projectCommonInfo.offerExpert.id} + '/info'` : ''
                    ">{{ offerExpertName }}</router-link>
                </p>

                <h4>направления</h4>
                <div>
                  <span v-for="(market, marketIndex) in projectCommonInfo.markets" :key="marketIndex + 'market_'">
                    {{ supMarketDict[market] }}
                  </span>
                </div>

                <v-checkbox label="Без договора" readonly v-model="projectCommonInfo.noContract"></v-checkbox>
              </div>

              <div>
                <h2>Описание</h2>
                {{ projectCommonInfo.description }}
              </div>
            </div>

            <div class="grid50">
              <div>
                <h2>
                  Договоры с заказчиками
                </h2>
                <ul class="requests-list">
                  <li v-if="customerContracts.length === 0">Нет договоров</li>
                  <template v-else>
                    <router-link v-for="(contract, index) in customerContracts"
                      :to="'/contract/' + contract.id + '/info'" :key="'myactivecontract_' + index">
                      <li>
                        <h4>{{ contract.customer.shortName || contract.customer.fullName }}</h4>
                        <p>{{ contract.theme }}</p>
                      </li>
                    </router-link>
                  </template>
                </ul>
              </div>

              <div>
                <h2>
                  Договоры с подрядчиками
                </h2>
                <ul class="requests-list">
                  <li v-if="supplierContracts.length === 0">Нет договоров</li>
                  <template v-else>
                    <router-link v-for="(contract, index) in supplierContracts"
                      :to="'/contract/' + contract.id + '/info'" :key="'myactivecontract_' + index">
                      <li>
                        <h4>{{ contract.supplier.shortName || contract.supplier.fullName }}</h4>
                        <p>{{ contract.theme }}</p>
                      </li>
                    </router-link>
                  </template>
                </ul>
              </div>
            </div>
          </v-tab-item>

          <v-tab-item>
            <finance-tab :project-id="projectId" :project-common-info="projectCommonInfo"></finance-tab>
          </v-tab-item>

          <v-tab-item>
            <participations-component :experts="experts" :partners="partners" :project-id="encrypted.id"
              :addit="encrypted.addit" :participation-encrypted="encrypted.data2"></participations-component>
          </v-tab-item>
        </v-tabs>
      </div>
    </div>
  </v-container>
</template>

<script>
import { projectKeyHolderNew } from '@/modules/KeysHolder';
import {
  dictToObject,
  getExpertShortName,
  loadDataToObject,
} from '@/modules/CommonUtils';
import { wiringsRegisterConfig } from '@/components/register/RegisterConfigs';
// import Register from './register/Register.vue';
import { projectStatusDict, supMarketDict } from '@/modules/NSI';
import ParticipationsComponent from '@/components/ParticipationsComponent';
import FinanceTab from '@/components/projects/ProjectComponent/Finance/FinanceTab.vue';

import api from '@/modules/api';
// import LettersComponent from "@/components/LettersComponent";

export default {
  name: 'ProjectComponent',
  components: { ParticipationsComponent, FinanceTab },
  props: {},
  data() {
    return {
      panel: [2],
      disabled: false,
      financeGraphShow: false,
      passportShow: false,
      encrypted: {},
      projectCommonInfo: {},
      customerContracts: [],
      supplierContracts: [],
      projectWInfo: [],
      projectWenc: [],
      manualProfitTouched: false,
      filterByGraph: {},
      filterByArticles: [],
      projectStatusDict: dictToObject(projectStatusDict),
      supMarketDict: dictToObject(supMarketDict),
      projectId: null,
      projectFinance: {},
      apiLoaded: false,
      config: wiringsRegisterConfig,
      resetKey: Math.random()
    };
  },
  methods: {
    loadData: loadDataToObject,
    async reloadRegisterTab() {
      this.resetKey = Math.random();
      await this.initialize();
      this.$forceUpdate();
    },
    updateFilterByArticles(filterArticles) {
      this.filterByArticles = filterArticles;
      this.filterByGraph = {}
    },
    updateFilterByGraph(filter) {
      this.filterByGraph = filter;
      this.filterByArticles = [];

    },
    async saveManualProfit() {
      this.manualProfitTouched = false;
      const encryptedData = await projectKeyHolderNew.encode(JSON.stringify(this.projectCommonInfo));
      let req = await api.putJson('/supmain/projects/', {
        id: this.projectId,
        data: encryptedData,
        year: this.projectCommonInfo.year,
      });
      if (!req.ok) {
        alert('Ошибка сохранения данных');
      }
    },
    async initialize() {
      this.apiLoaded = false;
      if (!projectKeyHolderNew.checkKey()) return;
      this.projectId = this.$route.params?.id;
      await Promise.all([
        this.loadData(
          '/supmain/experts?page=0&size=100&sort=id,asc&search=isRolePartner:true',
          'partners',
          false
        ),
        this.loadData(
          '/supmain/experts?page=0&size=100&sort=id,asc&search=isNonPartnerParticipant:true',
          'experts',
          false
        ),
        this.loadData(
          '/supmain/experts?page=0&size=100&sort=id,asc&search=isRoleOffer:true',
          'offerExperts',
          false
        ),
        this.loadData('/supmain/projects/' + this.projectId, 'encrypted', false),
      ]);
      const getFullName = function (items) {
        return items.map((e) => {
          e.fullName = [e.surname, e.name, e.middleName].join(' ');
          if (e.fullName === '  ') e.fullName = 'Без имени';
          return e;
        });
      };
      this.offerExperts = getFullName(this.offerExperts);
      this.partners = getFullName(this.partners);
      this.experts = getFullName(this.experts);

      this.projectCommonInfo = await projectKeyHolderNew.decode(
        this.encrypted.data,
      );
      this.projectCommonInfo.id = this.projectId;
      console.log('11111', this.projectCommonInfo)
      this.customerContracts = this.projectCommonInfo.customerContracts
      this.supplierContracts = this.projectCommonInfo.supplierContracts
      this.projectCommonInfo.number =
        this.encrypted.year + '-' + this.encrypted.numberInYear;
      this.apiLoaded = true;
    }
  },
  computed: {
  
    offerExpertName() {
      return getExpertShortName(
        this.offerExperts.find(
          (e) => e?.id === this.projectCommonInfo.offerExpert
        )
      );
    },
  },
  async beforeMount() {
    await this.initialize();
  },
};
</script>
<style scoped>
.position-relative {
  position: relative;
}

.table_font {
  font-size: 11px;
  font-weight: 300;
}

.table_font td {
  font-size: small;
}

.shortName_notificator {
  font-size: smaller;
  color: #919fbc;
}

.separator_line {
  color: #919fbc;
}

.requests-list {
  display: flex;
  gap: 20px;
  flex-direction: column;
  list-style-type: none;
  padding: 0;
}

.requests-list h4 {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 140%;
  color: #3577BE;
  margin: 0 0 10px 0;
}

.requests-list li:hover h4 {
  text-decoration: underline;
}
</style>
